
// iosinstaller
AddPageSwapTrigger(function () {
    if(window.navigator.standalone != true)  {
        if (typeof window.checkIosBanner === 'function' && window.checkIosBanner()) {
            $('body').addClass('display-iosbanner');
        }
    }

    $('a.closebanner').unbind('click');
    $('a.closebanner').click(function (e) {
        e.preventDefault();
        $('#iosinstall').hide();
        $('body').removeClass('display-iosbanner');

        $.cookie('hideiosinstall', 'hide', {
            expires: 60,
            path: '/'
        });
    });
});
